import { useRoomContext } from '@livekit/components-react';
import { ConnectionState, RoomEvent } from 'livekit-client';
import { useEffect } from 'react';

const IN_CALL_EVENT = 'telemedicine:patient-in-call';
const LEFT_CALL_EVENT = 'telemedicine:patient-left-call';

const useAnnounceInCall = () => {
	const room = useRoomContext();

	useEffect(() => {
		const announce = () => {
			if (room.state !== ConnectionState.Connected) {
				return;
			}

			window.socket?.emit(IN_CALL_EVENT);
		};

		announce();

		room.on(RoomEvent.Connected, announce);
		room.on(RoomEvent.Reconnected, announce);

		return () => {
			room.off(RoomEvent.Connected, announce);
			room.off(RoomEvent.Reconnected, announce);

			window.socket?.emit(LEFT_CALL_EVENT);
		};
	}, [room]);
};

export default useAnnounceInCall;
